import { useEffect, useRef } from "react";
import { useToast } from "@chakra-ui/react";

// Odds are polled every 1-3s, so a "no odds" toast would repeat on every poll.
// Show it once each time odds go missing, and re-arm it when odds come back.
export const useNoOddsNotification = (eventId) => {
  const toast = useToast();
  const notifiedRef = useRef(false);

  useEffect(() => {
    notifiedRef.current = false;
  }, [eventId]);

  const notifyNoOdds = () => {
    if (notifiedRef.current) return;
    notifiedRef.current = true;
    toast({
      title: "No odds found",
      status: "warning",
      duration: 3000,
      isClosable: true,
      position: "top",
    });
  };

  const resetNoOdds = () => {
    notifiedRef.current = false;
  };

  return { notifyNoOdds, resetNoOdds };
};
